import Badge from '@material-ui/core/Badge';
import ButtonBase from '@material-ui/core/ButtonBase';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const NothingToShow = props => {
  const classes = useStyles();
  return (
    <ListItem>
      <ListItemText
        secondary={'Nothing to show'}
      />
    </ListItem>
  );
};

const useStyles = makeStyles(theme => ({
  buttonBase: {
    width: '100%'
  },
  root: {
    width: '100%',
    display: 'flex'
  },
  listItem: {
    flex: 1
  },
  metadata: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  timestamp: {
    marginRight: 16,
    marginTop: 20,
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  badge: {
    marginRight: 26,
    marginTop: 10
  }
}));


export default NothingToShow;